import { JsonPipe } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [JsonPipe, TranslateModule],
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
})
export class StatsComponent  {
  public gpxStatsData: InputSignal<any> = input<any>();

}
